export const TwitterRound = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <circle cx='12' cy='12' r='12' fill='#2AA3EF' fillOpacity='0.1'></circle>
        <path
          fill='#2AA3EF'
          fillRule='evenodd'
          d='M16.922 8.947a4.05 4.05 0 01-1.16.318c.417-.25.738-.646.888-1.117-.39.231-.822.4-1.283.49a2.02 2.02 0 00-3.442 1.842 5.734 5.734 0 01-4.163-2.11 2.018 2.018 0 00.625 2.696 2.003 2.003 0 01-.915-.253v.026a2.02 2.02 0 001.62 1.98 2.016 2.016 0 01-.912.034 2.023 2.023 0 001.887 1.403 4.058 4.058 0 01-2.99.836 5.716 5.716 0 003.096.908c3.715 0 5.747-3.077 5.747-5.746 0-.088-.002-.174-.006-.261.395-.285.738-.64 1.008-1.046z'
          clipRule='evenodd'
        ></path>
      </svg>
    </span>
  );
};
